window.SapyenAnalytics = {
  track(eventName, properties = {}) {
    if (typeof window.amplitude?.track !== "function") {
      console.warn(`Amplitude unavailable: ${eventName}`);
      return;
    }

    return window.amplitude.track(eventName, properties);
  },

  identify(userId) {
    if (typeof window.amplitude?.setUserId !== "function") {
      console.warn("Amplitude unavailable: identify");
      return;
    }

    return window.amplitude.setUserId(String(userId));
  }
};